<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <div v-if="vouchers.length > 0" class="row mb-2">
            <div class="col-sm-4">
              <span class="badge badge-success mr-2">Total Search Data Found: {{ vouchers.length }}</span>
            </div>
          </div>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>SL</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Total attendance</th>
                <th>Vat</th>
                <th>Tax</th>
                <th>Sub total</th>
                <th>Total</th>
                <th>Payment Date</th>
                <th>Is Debited</th>
              </tr>
              </thead>
              <tbody>
              <tr  v-for="(voucher, index) in vouchers" :key="voucher.id">
                <td>{{ index + 1 }}</td>
                <td>{{ voucher.start_date }}</td>
                <td>{{ voucher.end_date }}</td>
                <td>{{ voucher.total_attendance }}</td>
                <td>{{ voucher.vat }}</td>
                <td>{{ voucher.tax }}</td>
                <td>{{ voucher.sub_total }}</td>
                <td>{{ voucher.total }}</td>
                <td>
                  <span v-if="voucher.payment_date !== null">{{ voucher.payment_date }}</span>
                  <span v-else>N/A</span>
                </td>
                <td>
                  <span v-if="voucher.is_debited === 1">Yes</span>
                  <span v-else>No</span>
                </td>
              </tr>
              </tbody>
            </table>
            <h5 v-if="vouchers.length === 0" class="text-center text-secondary">
              No Voucher Found
            </h5>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/profile-layout";
import PageHeader from "@components/page-header";
import http from "@state/http";

import moment from "moment";

export default {
  page: {
    title: "Voucher",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Voucher List",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Voucher",
          active: true
        }
      ],
      validation_errors: {},
      flag: false,
      vouchers: [],
    };
  },

  mounted() {
    this.getVoucher();
  },
  methods: {
    getVoucher() {
      let trainee_id = this.$route.params.trainee_id;
      http
          .post("api/trainee/profile/batch/list/" + trainee_id)
          .then(response => {
            if (!response.error) {
              this.flag = true;
              this.vouchers = response.data.vouchers;
            }
          });
    },
    customStartDate(date) {
      this.start_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>
<style lang="scss">
.vdp-datepicker input {
  width: 100%;
  border-radius: 3px;
  border: 1px solid #ced4da;
  height: 30px;
  padding-left: 15px;
  color: #6b757d;
}

.c-container {
  margin-right: 5px;
}
</style>